import React, { Component } from "react";
import Lexile from "react/views/readingLevel/Lexile";
import PropTypes from "prop-types";
import { attachFunctionToCallback } from "../../utility";
import { performJsonpGetRequest } from "../../lib/HttpRequest";
import { projectCarouselResults } from '../../data/CarouselItemSelector';
import SearchByLexileRangeUrl, { createLexileRangeNovelistLink } from "lib/titleSearch/lexileSearch/SearchByLexileRangeUrl";
import { getPrimaryIsbn } from 'data/TitleInfoSelector';
import { getJsonData, getProfileData } from "data/DataStore";
import { getOtsAvailabilityForResults } from "data/OtsRequests";

const lexileSearchCallbackName = "lexileSearchClbk";

class ReadingLevelContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			lexileSearchResult: null,
			lowerLexile: null,
			upperLexile: null
		};
		// bind before attaching them to novSelect
		this.handleSearch = this.handleSearch.bind(this);
		this.lexileSearchCallback = this.lexileSearchCallback.bind(this);

		attachFunctionToCallback(this.lexileSearchCallback, lexileSearchCallbackName);
	}

	lexileSearchCallback(data) {
		getOtsAvailabilityForResults(data);
		this.setState({
			isLoading: false,
			lexileSearchResult: data
		});
	}

	fetchResultForLexileSearch(lowerLexileScore, upperLexileScore) {
		let readingLevel = this.props.cardModel.audienceLevel;
		let searchByLexileRange = new SearchByLexileRangeUrl({ lowerLexileScore, upperLexileScore }, readingLevel);
		let apiEndpoint = searchByLexileRange.generateUrl();

		performJsonpGetRequest(apiEndpoint, lexileSearchCallbackName);
	}

	handleSearch(lowerLexile, upperLexile) {
		this.setState({
			isLoading: true,
			lowerLexile,
			upperLexile
		});

		this.fetchResultForLexileSearch(lowerLexile, upperLexile);
	}

	render() {
		let loggingId = getPrimaryIsbn(getJsonData());
		let novelistLink;

		if (this.state.lowerLexile && this.state.upperLexile) {
			let linkPrototype = getProfileData().PersistentQueryLinkPrototype;
			novelistLink = createLexileRangeNovelistLink(
				linkPrototype, 
				this.state.lowerLexile,
				this.state.upperLexile,
				this.props.cardModel.audienceLevel
			);
		}

		return (<Lexile
			handleSearch={this.handleSearch}
			lexile={this.props.cardModel.numericLexile}
			audienceLevel={this.props.cardModel.audienceLevel}
			resultData={projectCarouselResults(this.state.lexileSearchResult)}
			isLoading={this.state.isLoading}
			loggingId={loggingId}
			novelistLink={novelistLink}
			lowerLexile={this.state.lowerLexile}
			upperLexile={this.state.upperLexile}
			// OTS disabled currently until functionality is put in place
			otsEnabled={false}
		/>);
	}
}

ReadingLevelContainer.propTypes = {
	cardModel: PropTypes.object
};

export default ReadingLevelContainer;



// WEBPACK FOOTER //
// ./src/react/containers/ReadingLevelContainer.jsx